import rusaTeatro from './rusaTeatro';
import promokashka from './promokashka';

const list = [
  rusaTeatro,
  promokashka
];

export default list;